"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _navigationCategoryLink = _interopRequireDefault(require("./navigation-category-link"));

var KnowledgeBaseNavigation = function KnowledgeBaseNavigation(_ref) {
  var categories = _ref.categories,
      currentParent = _ref.currentParent,
      currentCategory = _ref.currentCategory;
  return (0, _preact.h)("div", {
    className: "knowledge-base-navigation-sidebar"
  }, categories.map(function (parentCategory) {
    var isCurrentParent = currentParent === parentCategory.id;
    var isCurrent = currentCategory === parentCategory.id;
    return (0, _preact.h)("div", {
      className: "knowledge-base-navigation-parent-wrapper",
      key: parentCategory.id
    }, (0, _preact.h)(_navigationCategoryLink.default, {
      url: parentCategory.url,
      isCurrent: isCurrent,
      key: "category-link-".concat(parentCategory.id)
    }, parentCategory.title), isCurrentParent ? (0, _preact.h)("div", {
      className: "knowledge-base-navigation-categories-block"
    }, parentCategory.subforums.map(function (category) {
      var isCurrent = currentCategory === category.id;
      return (0, _preact.h)(_navigationCategoryLink.default, {
        url: category.url,
        isCurrent: isCurrent,
        key: "category-link-".concat(category.id)
      }, category.title);
    })) : null);
  }));
};

var _default = KnowledgeBaseNavigation;
exports.default = _default;